import {
    CONFIRMED_GET_CAMPAIGNS,
    CONFIRMED_CREATE_CAMPAIGN,
    CONFIRMED_DELETE_CAMPAIGN,
    CONFIRMED_EDIT_CAMPAIGN,
    CONFIRMED_GET_CAMPAIGNS_BY_DATE
  } from "../types/CampaignTypes";
  
  const initialState = {
    list: [],
    num_rows: 0,
    target_date: null,
  };
  
  export default function CampaignReducer(state = initialState, action) {
    switch (action.type) {
      case CONFIRMED_GET_CAMPAIGNS:
        return {
          ...state,
          list: action.payload.list,
          num_rows: action.payload.num_rows,
        };
        case CONFIRMED_GET_CAMPAIGNS_BY_DATE:
          return {
            ...state,
            list: action.payload.list,
            num_rows: action.payload.num_rows,
            target_date: action.payload.target_date,
          };
      case CONFIRMED_CREATE_CAMPAIGN:
        return {
          ...state,
          list: [...state.list, action.payload],
        };
  
      case CONFIRMED_DELETE_CAMPAIGN:
        return {
          ...state,
          list: state.list.filter(
            (item) => item.campaign_id !== action.payload.campaign_id
          ),
        };
  
      case CONFIRMED_EDIT_CAMPAIGN:
        const updatedList = [...state.list];
        const index = updatedList.findIndex(
          (item) => item.campaign_id === action.payload.campaign_id
        );
  
        if (index !== -1) {
          updatedList[index] = action.payload;
        }
  
        return {
          ...state,
          list: updatedList,
        };
  
      default:
        return state;
    }
  }
  